import { z } from 'zod';
const INQUIRY_STATUSES = ['NEW', 'CONTACTED', 'ARCHIVED'];
export const createInquirySchema = z.object({
    name: z.string().min(1).max(255),
    email: z.string().email().max(255),
    phone: z.string().max(50).optional(),
    eventType: z.string().max(100).optional(),
    estimatedDate: z.string().max(50).optional(),
    estimatedGuestCount: z.number().int().min(1).max(10000).optional(),
    message: z.string().max(5000).optional(),
});
export const updateInquirySchema = z.object({
    status: z.enum(INQUIRY_STATUSES),
});
//# sourceMappingURL=inquiry.js.map